import { logCoreUsage } from 'owa-analytics';
import type { MailboxInfo } from 'owa-client-types';
import { getOverallSeedStatus } from 'owa-copilot-async-chat-store';
import { getSurfacedAsyncItems } from '../selectors/getSurfacedAsyncItems';
import { getTasksHubBacklog } from './getTasksHubBacklog';

export type TasksHubViewSource = 'drawerHeaderMenu' | 'dabViewAll' | 'dabInProgressSua';

export function logTasksHubViewed(mailboxInfo: MailboxInfo, source: TasksHubViewSource): void {
    logCoreUsage('AsyncChat_TasksHubViewed', mailboxInfo, {
        source,
        ...getTasksHubBacklog(getSurfacedAsyncItems(mailboxInfo)),
        seedStatus: getOverallSeedStatus(mailboxInfo),
    });
}
